import { connect } from 'react-redux';

import { StoreState } from '../../../../reducers';
import SliderPanel from '../../../../components/Editor/EditPanel/SliderPanel';

interface SliderPanelOwnProps {
	page: number;
}

const mapStateToProps = (state: StoreState, { page }: SliderPanelOwnProps) => {
	const {
		editor: {
			activeItem: { id },
			configs: { pagesData },
			editableSliders,
		},
	} = state;

	const { idInConfigs, deps, importingSlides, width, height } = editableSliders[page][id];
	const { sliders } = pagesData[page - 1];
	const sliderData = sliders![idInConfigs];
	const slides = 'slides' in sliderData ? sliderData.slides : sliderData;
	const settings = 'settings' in sliderData ? sliderData.settings : undefined;

	return {
		page,
		id,
		idInConfigs,
		slides,
		importingSlides,
		deps,
		sliderWidth: width,
		sliderHeight: height,
		shouldScaleImage: settings && !!settings.scaleImage,
	};
};

export default connect(mapStateToProps)(SliderPanel);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/EditPanel/SliderPanel/index.tsx